import { useAuth } from '@ixigo-packages/login/react';
import { createFileRoute, useRouter } from '@tanstack/react-router';
import { useEffect, useEffectEvent } from 'react';
import { getAuth } from '@/lib/login/auth';

export const Route = createFileRoute('/_auth')({
	beforeLoad: async () => {
		// Request-scoped server auth on the server, the browser singleton on the
		// client — both expose the same `isLoggedIn()`, no raw cookie access.
		const auth = await getAuth();
		if (!auth.isLoggedIn()) {
			throw new Error('NOT_LOGGED_IN');
		}
	},
	errorComponent: ({ error }) => {
		const notLoggedIn = error.message === 'NOT_LOGGED_IN';
		const { login } = useAuth();
		const router = useRouter();

		const startLogin = useEffectEvent(() => {
			// login() resolves with the user on success, null on dismiss. The funnel
			// is non-skippable here — LoginProvider sets hideSkip on /_auth — so the
			// user can't dismiss it back to this blank protected page. Invalidate
			// only on a real login (re-runs beforeLoad → the route renders); a null
			// (PWA-path dismiss) is a no-op rather than a re-throw loop.
			login().then(
				(user) => {
					if (user) router.invalidate();
				},
				() => {},
			);
		});

		// biome-ignore lint/correctness/useExhaustiveDependencies: startLogin is a useEffectEvent — stable by contract, must not be a dependency
		useEffect(() => {
			if (notLoggedIn) {
				startLogin();
			}
		}, [notLoggedIn]);

		if (notLoggedIn) {
			return null;
		}

		throw error;
	},
	ssr: false,
});
